<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    has from
    {{news.textParams[2]}}
    taken leave of absence from {{news.textParams[6]}} assignment as elected official to
    <router-link :to="{name: 'forum', params: {id: news.textParams[3]}}"
    >{{news.textParams[5]}}</router-link>
    During his/her absence he/she will be replaced.
  </div>
</template>
